import { render, staticRenderFns } from "./ModalShippingPrice.vue?vue&type=template&id=412ed71e&scoped=true&"
import script from "./ModalShippingPrice.vue?vue&type=script&lang=js&"
export * from "./ModalShippingPrice.vue?vue&type=script&lang=js&"
import style0 from "./ModalShippingPrice.vue?vue&type=style&index=0&id=412ed71e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "412ed71e",
  null
  
)

export default component.exports